import { formatRequestedModulesLabel, resolveCommercialModuleCatalog } from "@/lib/commercialLicenseRequests";
import { licenseTypeLabel } from "@/lib/licenseTypes";
import {
  cfdiUseSelectLabel,
  paymentMethodSelectLabel,
} from "@/lib/commercialInvoiceCatalog";
import {
  LICENSE_SCOPE_COST_DISCLAIMER,
  normalizeScopeFormFields,
  scopeRangeLabelClients,
  scopeRangeLabelUsers,
} from "@/lib/commercialLicenseScope";

export const LICENSE_CHANNEL_WEB = "web";
export const LICENSE_CHANNEL_PDF = "pdf";

export const LICENSE_CHANNEL_LABELS = {
  [LICENSE_CHANNEL_WEB]: "Solicitud web de licencia",
  [LICENSE_CHANNEL_PDF]: "Solicitud por PDF / manual",
};

/** Texto plano para copiar al portapapeles — solicitud PDF/manual. */
export function buildPdfSolicitudCopyText({ profile = {}, systemInfo = {}, form = {} }) {
  const inst = (systemInfo?.installation_id || "").trim() || "—";
  const razon = (profile.razon_social || form.razon_social || "").trim() || "—";
  const rfc = (profile.rfc || form.rfc || "").trim().toUpperCase() || "—";
  const email = (profile.email || profile.correo_facturacion || form.email || "").trim() || "—";
  const tel = (profile.telefono || form.telefono || "").trim() || "—";
  const catalog = resolveCommercialModuleCatalog(systemInfo);
  const licenseType = licenseTypeLabel(form.requested_license_type);
  const modules = formatRequestedModulesLabel(form.requested_modules, catalog) || "—";
  const scope = normalizeScopeFormFields(form);
  const requiresInvoice = Boolean(form.requires_invoice);
  const lines = [
    "Solicitud de licencia — Visor Fiscal BNT",
    "",
    `ID instalación: ${inst}`,
    `Razón social / nombre: ${razon}`,
    `RFC: ${rfc}`,
    `Correo: ${email}`,
    `Teléfono: ${tel}`,
    "",
    `Tipo de licencia solicitado: ${licenseType}`,
    `Módulos solicitados: ${modules}`,
    "",
    `Usuarios estimados: ${scope.estimated_users} (${scopeRangeLabelUsers(scope.estimated_users_range)})`,
    `Clientes/empresas estimados: ${scope.estimated_clients} (${scopeRangeLabelClients(scope.estimated_clients_range)})`,
    "",
    `Requiere factura: ${requiresInvoice ? "Sí" : "No"}`,
  ];
  if (requiresInvoice) {
    lines.push(
      `RFC facturación: ${(form.invoice_rfc || "").trim() || "—"}`,
      `Nombre / razón social facturación: ${(form.invoice_razon_social || "").trim() || "—"}`,
      `Régimen fiscal: ${(form.invoice_regimen_fiscal || "").trim() || "—"}`,
      `Código postal fiscal: ${(form.invoice_codigo_postal || "").trim() || "—"}`,
      `Domicilio fiscal: ${(form.invoice_fiscal_address || "").trim() || "—"}`,
      `Correo factura: ${(form.invoice_email || "").trim() || "—"}`,
      `Uso de CFDI: ${cfdiUseSelectLabel(form.invoice_cfdi_use)}`,
      `Forma de pago: ${paymentMethodSelectLabel(form.invoice_payment_method)}`,
    );
    if ((form.invoice_comments || "").trim()) {
      lines.push(`Comentarios de facturación: ${form.invoice_comments.trim()}`);
    }
  }
  if ((form.comments || "").trim()) {
    lines.push("", `Comentarios: ${form.comments.trim()}`);
  }
  lines.push(
    "",
    LICENSE_SCOPE_COST_DISCLAIMER,
    "",
    "(La vigencia y el plan los define BNT al autorizar la licencia.)",
  );
  return lines.join("\n");
}
